import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"

export default (sellers: any[] = []) => {
	const { t } = useTranslation("sellers", { keyPrefix: "form.dataTableHeaders" })

	return columns(t)
}

const columns = (t: TFunction) => [
	{
		key: "id",
		title: "ID",
		dataIndex: "id",
		sorteable: true,
		width: "3rem"
	},
	{
		key: "userEmail",
		title: t("user"),
		dataIndex: "userEmail",
		width: "8rem",
		ellipsis: true
	},
	{
		key: "seller",
		title: t("seller"),
		dataIndex: "seller",
		width: "8rem",
		ellipsis: true
	},
	{
		key: "contact",
		title: t("contact"),
		dataIndex: "contact",
		width: "8rem",
		ellipsis: true
	},
	{
		title: t("fiscalName"),
		dataIndex: "fiscalName",
		key: "fiscalName",
		width: "8rem",
		ellipsis: true
	},
	{
		title: t("fiscalCountry"),
		dataIndex: "fiscalCountry",
		key: "fiscalCountry",
		width: "8rem",
		ellipsis: true,
		filter: true
	},
	{
		title: t("nif"),
		dataIndex: "nif",
		key: "nif",
		width: "6rem"
	},
	{
		title: t("iban"),
		dataIndex: "iban",
		key: "iban",
		width: "6rem"
	},
	{
		title: t("web"),
		key: "web",
		dataIndex: "web",
		width: "8rem",
		ellipsis: true
	},
	{
		title: "",
		key: "editButton",
		dataIndex: "editButton",
		width: "3rem"
		// "fixed": "right"
	}
]
